// extracted by mini-css-extract-plugin
export default {"title":"V4-z","warning":"W4-z","sizeOptionsLegendText":"X4-z"};